(function () {
    'use strict';

    function skipTabbing() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                attrs.$set('tabindex', '-1');
            }
        };
    }

    skipTabbing.$inject = [];

    angular.module('ecap.common').directive('skipTabbing', skipTabbing);
})();